export default __webpack_public_path__ + "static/media/avatar_mei_ling2.f9703605.mp3";